// extracted by mini-css-extract-plugin
export default {"card":"BentoCard_card__RA0Zh","cardImg":"BentoCard_cardImg__G3c53","cardInfo":"BentoCard_cardInfo__R+iDz"};